<template>
  <div />
</template>

<script setup lang="ts">
import { type FlyToOptions, LngLatBounds, Map } from 'maplibre-gl'

const props = withDefaults(
  defineProps<{
    points: [number, number][]
    map: Map
    padding?: number | { top: number; right: number; bottom: number; left: number }
    // Zoom level for single points (for flyTo)
    zoom?: number
    duration?: number
    disabled?: boolean
  }>(),
  {
    padding: 100,
    duration: 500
  }
)

const emit = defineEmits<{
  (e: 'onZoomEnd', map: Map): void
}>()

const center = () => {
  if (props.points.length === 1) {
    const parameters: FlyToOptions = {
      center: [props.points[0][0], props.points[0][1]],
      duration: props.duration
    }

    if (props.zoom) {
      parameters.zoom = props.zoom
    }

    if (props.map) {
      props.map.flyTo(parameters)
    }

    return
  }

  const bounds = props.points.reduce(
    (bounds, coord) => bounds.extend(coord),
    new LngLatBounds(props.points[0], props.points[0])
  )

  props.map.fitBounds(bounds, {
    padding: props.padding,
    duration: props.duration
  })

  const callback = () => {
    props.map.off('moveend', callback)
    emit('onZoomEnd', props.map)
  }

  props.map.on('moveend', callback)
}

watch(
  () => props.points,
  (newValue, oldValue) => {
    if (props.disabled) return

    if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return

    center()
  }
)

onMounted(() => {
  if (props.disabled) return

  center()
})
</script>
